import * as angular from 'angular';

export class DownloadFileService {
    private fileSaver;

    constructor(FileSaver) {
        this.fileSaver = FileSaver;
    }

    transformArrayBufferToJson(arrayBuffer) {
        const decoder = new TextDecoder();
        const decodedArrayBuffer = decoder.decode(arrayBuffer);

        return JSON.parse(decodedArrayBuffer);
    }

    downloadFile(httpResponse) {
        const arrayBuffer = httpResponse.data;
        const contentType = httpResponse.headers('content-type');
        const fileName = this.getFileName(
            httpResponse.headers('content-disposition')
        );

        const blob = new Blob([arrayBuffer], {
            type: contentType,
        });

        this.fileSaver.saveAs(blob, fileName);
    }

    private getFileName(contentDisposition) {
        var filename = contentDisposition.split(';')[1].trim().split('=')[1];

        if (filename.toLowerCase().startsWith("utf-8''")) {
            filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
            filename = filename.replace(/['"]/g, '');
        }

        return filename;
    }
}

angular.module('app').service('DownloadFileService', DownloadFileService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/download-file.service.ts